import React from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Floating sticky cart button — appears only when cart has items.
 * Always visible on all viewports for fast access from any page.
 */
export default function StickyCartButton() {
  const { t } = useLanguage();
  const { totalItems, openCart } = useCart();

  if (totalItems === 0) return null;

  return (
    <button
      type="button"
      onClick={openCart}
      className="fixed bottom-[calc(env(safe-area-inset-bottom)+4.75rem)] end-4 z-[60] inline-flex h-12 max-w-[calc(100vw-5rem)] items-center gap-2.5 rounded-full bg-[#111] ps-4 pe-5 text-white shadow-[0_14px_34px_rgba(0,0,0,0.25)] transition-colors hover:bg-[#F37021] md:bottom-24 md:end-5 md:h-14 md:gap-3 md:ps-5 md:pe-6"
      data-testid="sticky-cart-button"
      aria-label={`${t.store.cartTitle} (${totalItems})`}
    >
      <span className="relative">
        <ShoppingBag className="w-5 h-5" />
        <span className="absolute -top-2 -end-2 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F37021] text-[10px] font-bold flex items-center justify-center">
          {totalItems}
        </span>
      </span>
      <span className="truncate text-xs font-semibold md:text-sm">{t.store.cartTitle}</span>
    </button>
  );
}
